/**
 * Map creditCardToken request to Visitor cc token
 *
 * @param {creditCardToken}
 * @returns {CreditCardTokenDTO}
 */
export const mapPostSingleCreditCardTokenRequest = (creditCardToken) => {
  return {
    gateway_id: creditCardToken?.gatewayId?.toString() || "",
    token: creditCardToken?.cardToken?.toString() || "",
    cc_last_four_digits: creditCardToken?.cardLast4?.toString() || "",
    cc_expiration_date: creditCardToken?.cardExpDate?.toString() || "",
    cardholder: creditCardToken?.cardHolderName?.toString() || ""
  };
};
